import { render, staticRenderFns } from "./MakerDai.vue?vue&type=template&id=6bc9a04e&scoped=true&"
import script from "./MakerDai.vue?vue&type=script&lang=js&"
export * from "./MakerDai.vue?vue&type=script&lang=js&"
import style0 from "./MakerDai.vue?vue&type=style&index=0&id=6bc9a04e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc9a04e",
  null
  
)

export default component.exports